// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: shared/api/common/ENUM_MortgagePartStepType.proto

export enum ENUM_MortgagePartStepType {
  MORTGAGE_PART_STEP_TYPE_UNSPECIFIED = 'MORTGAGE_PART_STEP_TYPE_UNSPECIFIED',
  MORTGAGE_PART_STEP_TYPE_FIXED = 'MORTGAGE_PART_STEP_TYPE_FIXED',
  MORTGAGE_PART_STEP_TYPE_VARIABLE = 'MORTGAGE_PART_STEP_TYPE_VARIABLE',
  UNRECOGNIZED = 'UNRECOGNIZED',
}
